module.exports = __webpack_public_path__ + "img/3.4e4496e7.png";